import { infos_to_display } from "../settings";

export const Title = ({ image }) => {
  const title = (image.exifs && image.exifs.title) || (image.meta && image.meta.title);

  if (!title || !infos_to_display.title) {
    return null;
  }

  return (
    <h2 dangerouslySetInnerHTML={{__html: title}} />
  );
};